import { useQuery } from '@tanstack/react-query';
import { getNote } from '../api';
import type { Note } from '../types/note';

export function useNote(id: number | null) {
  const { data: note, isLoading, error, refetch } = useQuery({
    queryKey: ['note', id],
    queryFn: async () => {
      if (!id) return null;
      return await getNote(id);
    },
    enabled: !!id, // Only run the query if we have an ID
    staleTime: 30 * 1000, // Consider data fresh for 30 seconds
  });

  return {
    note,
    isLoading,
    error,
    refetch
  };
}
